import React from "react"
import Menu, { MenuProps } from "@mui/material/Menu"

type DropdownContextProps = {
  anchorEl: HTMLElement | null
  handleClick: (event: React.MouseEvent<HTMLElement>) => void
  handleClose: () => void
}

const DropdownContext = React.createContext<DropdownContextProps>({
  anchorEl: null,
  handleClick: () => {},
  handleClose: () => {},
})

export const useDropdownContext = () => React.useContext(DropdownContext)

type DropdownProviderProps = {
  children: React.ReactNode
}

export const DropdownProvider: React.FC<DropdownProviderProps> = ({ children }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return <DropdownContext.Provider value={{ anchorEl, handleClick, handleClose }}>{children}</DropdownContext.Provider>
}

type DropdownMenuProps = Omit<MenuProps, "anchorEl" | "open" | "onClose"> & {
  children: React.ReactNode
}

export const DropdownMenu: React.FC<DropdownMenuProps> = ({ children, ...props }) => {
  const { anchorEl, handleClose } = useDropdownContext()

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose} {...props}>
      {children}
    </Menu>
  )
}
